<template>
  <v-card
    class="mx-auto rounded-card card-shadow"
    v-bind="$attrs"
  >
    <v-card-text class="text--primary">
      <figure>
        <v-chart :options="chart"
                 ref="savingChart"
                 theme="primary"
                 autoresize/>
      </figure>
    </v-card-text>
  </v-card>
</template>

<script>
import chartMixin from '@/mixins/chart-mixin';
import { buildTimeframeChart, toEchartData } from '@/utils/chart-utils';
import IndicadoresService from './dashboard-service';

export default {
  mixins: [chartMixin],
  props: {
    stringFilter: String,
  },
  data() {
    return {
      savings: null,
      totais: null,
      chart: null,
    };
  },
  watch: {
    stringFilter(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.updateChartData();
    },
  },
  methods: {
    showLoading() {
      this.$refs.savingChart.showLoading(this.loadingConfig);
    },
    hideLoading() {
      if (!this.$refs.savingChart) {
        return;
      }
      this.$refs.savingChart.hideLoading();
    },
    buildChart() {
      const savings = buildTimeframeChart(this.savings);
      return {
        title: {
          text: 'Savings para o período',
        },
        tooltip: {
          formatter: this.tooltipFormatter,
        },
        dataset: {
          source: [
            ['Saving'],
            ...toEchartData(savings, 'description', 'value'),
          ],
        },
        xAxis: {
          type: 'category', interval: 1, maxInterval: 1, splitNumber: 1,
        },
        yAxis: {
          axisLabel: {
            formatter: this.axisMoneyFormatter,
          },
        },
        grid: {
          left: '15%',
        },
        series: [{ type: 'bar' }],
      };
    },
    getComprasTotais() {
      const filter = this.stringFilter;
      IndicadoresService.getCompras({ filter })
        .then((response) => {
          this.totais = response.data;
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    getSavings() {
      const filter = this.stringFilter;
      this.showLoading();
      IndicadoresService.getSavings({ filter })
        .then((response) => {
          this.savings = response.data;
          this.chart = this.buildChart();
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    updateChartData() {
      this.getSavings();
      this.getComprasTotais();
    },
  },
  mounted() {
    this.updateChartData();
  },
};
</script>

<style scoped>
figure .echarts {
  width: 100%;
  height: 300px;
}
</style>
